import { html } from '../lib/html.js';
import { reviews } from '../services/reviews.js';
import { Page } from './base.js';
import { reportReview, reviewCard } from './review-ui.js';

/** Todas as avaliações de uma oficina (/oficinas/:workshopId/avaliacoes), 20 por página, com denúncia. */
class ShowcaseReviewsPage extends Page {
  template() {
    return html`
      <ion-header translucent>
        <ion-toolbar>
          <ion-buttons slot="start"><ion-back-button default-href="/oficinas" text="Voltar"></ion-back-button></ion-buttons>
          <ion-title>Avaliações</ion-title>
        </ion-toolbar>
      </ion-header>
      <ion-content class="ion-padding surface-page" fullscreen>
        <div class="narrow">
          <p class="rv-note"><ion-icon name="shield-checkmark-outline" aria-hidden="true"></ion-icon>Só avalia quem teve um serviço registrado por esta empresa no TicketCar.</p>
          <div class="list"></div>
          <ion-button expand="block" fill="outline" class="more" hidden>Ver mais</ion-button>
        </div>
      </ion-content>`;
  }

  get wid() {
    if (this.workshopId) return String(this.workshopId);
    return decodeURIComponent(location.pathname.match(/\/oficinas\/([^/?#]+)/)?.[1] ?? '');
  }

  setup() {
    this.$('.list').addEventListener('click', (e) => {
      const r = e.target.closest('[data-action="report"]');
      if (r) reportReview(r.dataset.id, r.dataset.reply === '1');
    });
    this.$('.more').addEventListener('click', () => this.load(this.page + 1));
  }

  onEnter() {
    this.$('.list').innerHTML = '<div class="center-small"><ion-spinner></ion-spinner></div>';
    this.load(1);
  }

  async load(page) {
    try {
      const r = await reviews.ofWorkshop(this.wid, page);
      this.page = page;
      const items = r.items.map((x) => reviewCard(x, { reportable: true }).value).join('');
      if (page === 1) this.$('.list').innerHTML = items || html`<div class="panel"><p class="panel-text">Esta empresa ainda não tem avaliações.</p></div>`.value;
      else this.$('.list').insertAdjacentHTML('beforeend', items);
      const more = this.$('.more');
      more.style.display = page < r.pages ? '' : 'none';
    } catch (e) {
      this.$('.list').innerHTML = html`<div class="panel"><p class="panel-text">${e.message}</p></div>`.value;
    }
  }
}

customElements.define('page-showcase-reviews', ShowcaseReviewsPage);
